import { CampaignType, DialModes } from '../campaign.const';
import { UtilityService } from '../../../../../common/services/Utility.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { showPhoneNumberInString, formatDob } from '../../../../../common/utils/common';
export enum StatusSipChunk {
  SUCCESS = '200',
  UNAUTHORIZED = '401',
  PAYMENT_REQUIRED = '402',
  NOT_RELAYING = '403',
  NOT_FOUND = '404',
  REQUEST_TIMEOUT = '408',
  BAD_EXTENSION = '420',
  FLOW_FAILED = '430',
  TEMPORARILY_UNAVAILABLE = '480',
  AMBIGUOUS = '485',
  BUSY_HERE = '486',
  REQUEST_TERMINATED = '487',
  NOT_ACCEPTABLE_HERE = '488',
  INTERNAL_SERVER_ERROR = '500',
  SERVICE_UNAVAILABLE = '503',
  DECLINE = '603',
  UNWANTED = '607',
  REJECTED = '608',
  NOT_FOUND_DEFINE = '704',
  CALLOUT_PERMISSION_DENY = '550',
  // error
  REQUEST_TIMEOUT_ACD = '504',
  REQUEST_TIMEOUT_AGENTSERVER = '504',
  TIMEOUT_IN_QUEUE = '700',
  INVALID_INPUT = '400',
}
export const getStatusCodeSipChunk = status => {
  if (!status || status == '0') {
    return '';
  }
  switch (status) {
    case StatusSipChunk.SUCCESS:
      return 'Thành công';
    case StatusSipChunk.REQUEST_TIMEOUT:
      return 'Không trả lời';
    case StatusSipChunk.BAD_EXTENSION:
      return 'Sai định dạng số';
    case StatusSipChunk.FLOW_FAILED:
      return 'Chuyển hướng/voicemail';
    case StatusSipChunk.TEMPORARILY_UNAVAILABLE:
      return 'Không liên lạc được';
    case StatusSipChunk.AMBIGUOUS:
      return 'Thuê bao không tồn tại';
    case StatusSipChunk.BUSY_HERE:
      return 'Bị từ chối';
    case StatusSipChunk.REQUEST_TERMINATED:
      return 'Người gọi ngắt';
    case StatusSipChunk.NOT_ACCEPTABLE_HERE:
      return 'Thuê bao bận';
    case StatusSipChunk.INTERNAL_SERVER_ERROR:
      return 'Lỗi server';
    case StatusSipChunk.SERVICE_UNAVAILABLE:
      return 'Lỗi kết nối';
    case StatusSipChunk.DECLINE:
      return 'Thuê bao bị khóa';
    case StatusSipChunk.UNWANTED:
      return 'Đã bị chặn';
    case StatusSipChunk.REJECTED:
      return 'Hệ thống quá tải';
    case StatusSipChunk.NOT_FOUND_DEFINE:
      return 'Tất cả agent bận';
    case StatusSipChunk.CALLOUT_PERMISSION_DENY:
      return 'Lỗi quyền gọi ra';
    default:
      return 'Khởi tạo lỗi';
  }
};

export class DetailCampaignConst {
  static displayColumn = (type?: any, fields: { title: string; key: string }[] = [], mode?: any) => {
    let data = [
      {
        title: 'Khách hàng',
        key: 'display_name',
        display: true,
        allowSort: false,
        classes: 'font-weight-700',
        field: 'name',
      },
      {
        title: 'Số điện thoại',
        key: 'display_phone',
        display: true,
        allowSort: false,
        classes: '',
        field: 'phone',
      },
      {
        title: 'Ngày sinh',
        key: 'display_dob',
        display: true,
        allowSort: false,
        classes: '',
        field: 'dob',
      },
      {
        title: 'Email',
        key: 'display_email',
        display: true,
        allowSort: false,
        classes: '',
        field: 'email',
      },
      {
        title: 'Tổ chức',
        key: 'display_organize',
        display: true,
        allowSort: false,
        classes: '',
        field: 'organize_id',
      },
      {
        title: 'Thành phố',
        key: 'display_city',
        display: true,
        allowSort: false,
        classes: '',
        field: 'city_id',
      },
      {
        title: 'Thời gian',
        key: 'display_created_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'created_at',
      },
      {
        title: type === CampaignType.Call ? 'Số lần gọi' : 'Số lần gửi',
        key: 'retry_total',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'retry_total',
      },
      {
        title: 'Trạng thái',
        key: 'display_status',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'status',
      },
      {
        title: 'Ticket',
        key: 'display_ticket',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'ticket_id',
      },
      {
        title: 'Chuyên viên',
        key: 'display_assignee',
        display: true,
        allowSort: false,
        classes: '',
        field: 'assign_agent_id',
      },
    ];
    if (mode === DialModes.AutodialIvr) {
      data = [
        ...data,
        {
          title: 'Kịch bản IVR',
          key: 'display_cpName',
          display: true,
          allowSort: false,
          classes: '',
          field: 'cpName',
        },
        {
          title: 'Hành động đầu tiên',
          key: 'display_firstActionIvr',
          display: true,
          allowSort: false,
          classes: '',
          field: 'firstActionIvr',
        },
        {
          title: 'Hành Động IVR',
          key: 'display_dtmf',
          display: true,
          allowSort: false,
          classes: '',
          field: 'dtmf',
        },
      ];
    }
    if (fields.length > 0) {
      fields.forEach(f => {
        data.push({
          title: f.title,
          key: 'display_' + f.key,
          display: true,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }
    return data;
  };
  static displayFieldColumn = (data, t) => {
    if (!data) return '';
    return data[t.key]
      ? t.type === 'date'
        ? moment(data[t.key]).add('-7', 'hours').format('YYYY-MM-DD HH:mm')
        : data[t.key]
      : '';
  };
  static displayNameColumn = (item, user) => {
    return item.name ? showPhoneNumberInString(item.name, user) : '';
  };
  static displayPhoneColumn = (item, user) => {
    return item.phone ? showPhoneNumberInString(item.phone, user) : '';
  };
  static displayEmailColumn = user => {
    return user.email ? user.email : '';
  };
  static displayFirstActionIvrColumn = user => {
    return user.firstActionIvr ? user.firstActionIvr : '';
  };
  static displayCpNameColumn = user => {
    return user.cpName ? user.cpName : '';
  };
  static displayDtmfColumn = user => {
    return user.dtmf ? user.dtmf : '';
  };
  static displayOrganizeColumn = (user, organizes) => {
    return user.organize_id && organizes[user.organize_id] ? organizes[user.organize_id].name : '';
  };
  static displayCityColumn = (user, cities) => {
    return user.city_id && cities[user.city_id] ? cities[user.city_id].name : '';
  };
  static displayTicketColumn = user => {
    return user.ticket_id ? `<span class="link-ticket">${user.ticket_id}</span>` : '';
  };
  static displayTicketAssigneeColumn = (ticket, agents) => {
    if (!ticket) return '';
    const agent = agents.find(agent => agent._id === ticket.assign_agent_id);
    if (!agent) return '';
    return `<span class="link-user">${agent.name}</span>`;
  };
  static displayTimeColumns = time => {
    return UtilityService.dateFormat(time);
  };
  static displayDob = item => {
    return formatDob(item.dob);
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/detail/detail.const.ts